package com.cybersoftsolution.cybersoftsolutionweb.components.carousel

import androidx.compose.runtime.Composable
import androidx.compose.runtime.*
import com.cybersoftsolution.cybersoftsolutionweb.models.MyElement
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*
import com.cybersoftsolution.cybersoftsolutionweb.styles.HalfBlackButtonStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.contentRectElementObserver
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import kotlinx.coroutines.delay
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement

@Composable
inline fun <reified T : MyElement>MyHorizontalCarousel(
    id: String,
    modifier: Modifier = Modifier,
    elements: List<T>,
    slideShow: Boolean = true,
    pauseSlideShow: Boolean = false,
    previewButtonText: String? = null,
    nextButtonText: String? = null,
    slideDurationInSeconds: Int = 3,
    animationDurationInMilliseconds: Number = 500,
    initIndex: Int = 0,
    crossinline onForceToContinue: () -> Unit = {},
    crossinline onResponsiveWidthChange: (Int?) -> Unit = {} ,
    crossinline content: @Composable (T) -> Unit
) {

    val breakpoint = rememberBreakpoint()


    var currentIndex by remember { mutableStateOf(initIndex) }
    var responsiveWidth by remember { mutableStateOf(0) }
    var pause by remember { mutableStateOf(pauseSlideShow) }

    //Para pausar el carrusel desde afuera
    LaunchedEffect(pauseSlideShow) {
        pause = pauseSlideShow
    }


    //Libreria externa para el swipe horizontal en el carrusel
    var hammerInitialized by remember { mutableStateOf(false) }

    //Inicializar la libreria externa para el swipe horizontal en el carrusel
    LaunchedEffect(responsiveWidth) {
        if (!hammerInitialized) {
            val carouselDiv = document.getElementById(id) as? HTMLElement
            if (carouselDiv != null) {
                val hammerTime = js("new Hammer(carouselDiv)")

                hammerTime.get("swipe").set(js("{ direction: Hammer.DIRECTION_HORIZONTAL }")) // Configurar solo swipe horizontal

                hammerTime.on("swipeleft", { dynamic ->
                    currentIndex = (currentIndex + 1) % elements.size
                    dynamic
                })
                hammerTime.on("swiperight", { dynamic ->
                    currentIndex = (currentIndex - 1 + elements.size) % elements.size
                    dynamic
                })
                hammerInitialized = true
            }
        }
    }



    //Autoplay del carrusel cuando se inicia la pagina y pausar si hace falta
    LaunchedEffect(Unit,currentIndex,pause) {
        if (slideShow && !pause) {
            delay(slideDurationInSeconds * 1000L)
            currentIndex = (currentIndex + 1) % elements.size
        }
    }

    LaunchedEffect(Unit,breakpoint) {
        //Obtener el ancho del elemento por primera vez
        responsiveWidth = (document.getElementById(id) as? HTMLDivElement)?.offsetWidth ?: 0

        //Observar el ancho del elemento
        contentRectElementObserver.observeElementById(id)
        contentRectElementObserver.contentSizeFlow.collect { (idObserve, contentSize) ->
            when (idObserve) {
                id -> responsiveWidth = contentSize.width.toInt()
            }
        }
    }


    //Detectar cambios en el ancho del elemento
    LaunchedEffect(responsiveWidth) {
        onResponsiveWidthChange(responsiveWidth)
    }

    //Al Deslizar el carusel por cualquier via despausar el autoplay
    LaunchedEffect(currentIndex) {
        pause = false
        onForceToContinue()
    }

//    LaunchedEffect(elements) {
//        onResponsiveWidthChange(responsiveWidth)
//    }



    Div(
        attrs =  modifier
            .id(id)
            .overflow(Overflow.Hidden)
            .position(Position.Relative)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
            .toAttrs()
    ) {
        Div(
            attrs =  Modifier
                .display(DisplayStyle.Flex)
                .transition(
                    Transition.of(
                        property = TransitionProperty.of("transform"), // Corrección: usar of("transform")
                        duration = animationDurationInMilliseconds.ms, // Duración de la transición
                        timingFunction = TransitionTimingFunction.EaseInOut, // Función de tiempo
                        delay = null
                    )
                )
                .transform {
                    translateX((-currentIndex * responsiveWidth).px)
                }
                .toAttrs()
        ) {
            elements.forEach { element ->
                Div(
                    attrs = Modifier
                        .width(responsiveWidth.px)
                        .flexShrink(0)
                        .padding(10.px)
                        .toAttrs()


                ) {
                    content(element)
                }

            }
        }

        previewButtonText?.let {
            Button(
                attrs = HalfBlackButtonStyle.toModifier()
                    .position(Position.Absolute)
                    .top(50.percent)
                    .transform { // Usar el bloque transform {}
                        translateY((-50).percent) // translateY acepta CSSPercentageValue
                    }
                    .thenIf(
                        condition = previewButtonText == nextButtonText,
                        other = Modifier
                            .scaleX(-1)
                    )
                    .padding(10.px, 20.px)
                    .border(0.px)
                    .left(10.px)
                    .onClick { currentIndex = (currentIndex - 1 + elements.size) % elements.size }
                    .toAttrs()

            ) { Text(it) }
        }

        nextButtonText?.let {
            Button(
                attrs = HalfBlackButtonStyle.toModifier()
                    .position(Position.Absolute)
                    .top(50.percent)
                    .transform { // Usar el bloque transform {}
                        translateY((-50).percent) // translateY acepta CSSPercentageValue
                    }
                    .padding(10.px, 20.px)
                    .border(0.px)
                    .right(10.px)
                    .onClick { currentIndex = (currentIndex + 1) % elements.size }
                    .toAttrs()
            ) { Text(it) }
        }


        //Actualizar el ancho del elemento cuando se terminan de cargar los elementos
        onResponsiveWidthChange(responsiveWidth)

    }
}
